import { DesignedRateBase } from './base/designed-rate-base';

export class DesignedRate extends DesignedRateBase { }